<template>
  <div class="swiper-main-slide-2">
    <slot name="video"></slot>
    <slot name="image"></slot>
  </div>
  <div
    class="swiper-main-slide__content"
    :class="[
      contentPosition === 'top' ? 'swiper-main-slide__content--top' : '',
      isOnlyMobileTitle ? 'swiper-main-slide__content--mobile' : '',
    ]"
  >
    <h2 class="swiper-main-slide__title">
      <slot name="title"></slot>
    </h2>

    <button
      v-if="isViewBtn"
      @click="toggleRequestForm($event)"
      class="swiper-main-slide__content__button btn-primary"
    >
      <slot name="sliderButton"></slot>
    </button>

    <template v-if="isViewLink && link">
      <a
        :href="link"
        target="_blank"
        class="swiper-main-slide__content__button btn-primary"
      >
        <slot name="linkText"></slot>
      </a>
    </template>
  </div>
</template>

<script>
// import TimeCounter from "./TimeCounter.vue";

export default {
  name: "SliderComponent",
  // components: { TimeCounter },
  data() {
    return {};
  },
  props: {
    isViewBtn: {
      type: Boolean,
      default: true,
    },
    isViewLink: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: "",
    },
    isOnlyMobileTitle: {
      type: Boolean,
      default: false,
    },
    contentPosition: {
      type: String,
      default: "bottom",
    },
  },
  methods: {
    toggleRequestForm(event) {
      this.emitter.emit("open-request-form", {
        open: false,
        title: event.target.innerText,
        form_position: "форма второго баннера",
      });
    },
  },
};
</script>
